<template>
    <div class="newBox">
        <span class="icon">热点</span>
        <div class="newBoxContent">
            <el-carousel height="24px" direction="vertical">
                <el-carousel-item v-for="item in noticelist.dataList" :key="item.id">
                    <div class="medium more_text1" @click="openUrl(item)">{{ item.title }}</div>
                </el-carousel-item>
             </el-carousel>
        </div>
        <span class="more" @click="dialogVisible = true">更多</span>
        <noticeDialog v-if="dialogVisible" @close="dialogVisible = false" title="活动小喇叭" :categoryId="1"></noticeDialog>
    </div>
</template>

<script>
import noticeDialog from './noticeDialog'
import home from '@/services/home'
export default {
    components: { noticeDialog },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            noticelist: {
                dataList: [],
                total: 0
            }
        }
    },
    created() {
        this.getMessage()
    },
    methods: {
        getMessage() {
            let data ={
                pageSize: 10,
                pageNumber: 1,
                categoryId: 1
            }
            home.getMessage(data).then(res => {
                this.noticelist.dataList = res.result.data
                this.noticelist.total = res.result.total;
            })
        },
        openUrl(item) {
            window.open(item.urlLink)
        }
    },
}
</script>

<style lang="scss" scoped>
.newBox{
    width: 100%;
    height: 50px;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
    line-height: 26px;
    margin-bottom: 24px;
    // overflow: hidden;
    .icon{
        float: left;
        padding-left: 26px;
        color: #FF3400;
        font-size: 16px;
        background: url('../../../../assets/icon/hot.png') left center / 18px 24px no-repeat;
        margin-right: 16px;
        width: 50px;
    }
    .more{
        color: #000;
        font-size: 14px;
        padding-right: 20px;
        width: 40px;
        cursor: pointer;
        background: url('../../../../assets/icon/angle.png') right center / 20px 20px no-repeat;
    }
    .newBoxContent{
        width: 100%;
        height: 24px;
        overflow-y: auto;
    }
    .medium{
        cursor: pointer;
    }
}
</style>
